import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { preloadCreateSpace } from '@confluence/create-space-preload/entry-points/preloadCreateSpace.ts';

import useSpacesDataStarredSpacesQuery from './__generated__/useSpacesDataStarredSpacesQuery.graphql.ts';
import useSpacesDataMyVisitedSpacesQuery from './__generated__/useSpacesDataMyVisitedSpacesQuery.graphql.ts';
import useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery from './__generated__/useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery.graphql.ts';
import useSpacesDataAnonymousSpacesQuery from './__generated__/useSpacesDataAnonymousSpacesQuery.graphql.ts';

type preloadSpacesListOptions = {
	isLicensed: boolean;
	selectedSpaceKey?: string;
};

export const preloadSpacesList = ({
	isLicensed,
	selectedSpaceKey,
}: preloadSpacesListOptions): Promise<
	| void
	| Error[]
	| {
			data: unknown;
	  }[]
> => {
	const preloadQueries = [];

	if (isLicensed) {
		preloadQueries.push(
			query({
				query: useSpacesDataStarredSpacesQuery,
				variables: {},
			}),
		);
		if (selectedSpaceKey) {
			preloadQueries.push(
				query({
					query: useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery,
					variables: { selectedSpaceKey },
				}),
			);
		} else {
			preloadQueries.push(
				query({
					query: useSpacesDataMyVisitedSpacesQuery,
					variables: {},
				}),
			);
		}
	} else {
		preloadQueries.push(
			query({
				query: useSpacesDataAnonymousSpacesQuery,
				variables: {},
			}),
		);
	}

	preloadQueries.push(preloadCreateSpace({ isLicensed }));

	return waitForAllReturnWhenError(preloadQueries);
};
